// user - 頭像
import Image from 'next/image';

const UserThumbnail = ({
    dispatch,
    setShowUserModal,
    thumbnail,
    showUserModal,
    isCategoryPath,
    avatarFrame,
}) => {
    // 點擊頭像
    const onClickUser = () => dispatch(setShowUserModal(!showUserModal));

    return (
        <button
            onClick={onClickUser}
            className={`group relative ${
                isCategoryPath ? 'hover:border-opacity-[1]' : 'hover:border-plum'
            } ulg:hidden`}
        >
            {thumbnail && (
                <Image
                    className={`rounded-[50%] object-cover object-center w-full h-full hover-img !filter-none
                        ${avatarFrame ? '!w-[95%] set-center !h-[95%]' : ''}`}
                    width={32}
                    height={32}
                    src={thumbnail}
                    alt="thumbnail"
                />
            )}
            {avatarFrame && (
                <Image
                    className="absolute !w-[120%] !h-[120%] set-center !max-w-[unset] !z-[2] set-center !object-contain"
                    width={34}
                    height={34}
                    src={avatarFrame}
                    alt="frame"
                />
            )}
        </button>
    );
};

export default UserThumbnail;
